import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import "./order-summary.scss";
import { statusCode } from "../../services/apiConstants";
import Header from "../../components/header/header";
import RestoCard from "../../components/resto-card/resto-card";
import Rewards from "../../components/rewards/rewards";
import Button from "../../components/button/button";
import ModalPopUp from "../../components/modal/modal";
import Loader from "../../components/loader/loader";
import DineInPaymentAPI from "../../services/DineInPayment/DineInPayment";
import PaymentStatusAPI from "../../services/PaymentStatus/PaymentStatus";
import ValidateOffer from "../../services/ValidateOffer/ValidateOffer";
import { discountCalculator } from "../../utils";
import SuccessIcon from "../../assets/success.json";
import ErrorIcon from "../../assets/error.json";
import Ribbons from "../../assets/ribbons.json";
import Lottie from "lottie-react";
import {pageUrl} from "../../utils/pageConstant";
import OfferCard from "../../components/offer-card/offer-card";
import OfferPopUp from "../../components/offer-dialog/offer-dialog";
import RestoDetail from "../../components/resto-detail/resto-detail";
import Conditions from "../../components/condition/condition";
import UserTraction from "../../services/UserTraction/UserTraction";
import GetPromoCodeInfo from "../../services/GetPromoCodeInfo/GetPromoCodeInfo";

const MAX_REWARD_POINTS = 5000; //Maximum reward points for a single transaction

const BreakUp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const outletDetailsInfo = useSelector((state) => state.outlet.outletDetails);
  const outletDetailsSession = JSON.parse(
    localStorage.getItem("outletDetailsInfo")
  );
  const [outletDetails] = useState(
    Object.keys(outletDetailsInfo === 0)
      ? outletDetailsSession
      : outletDetailsInfo
  );
  const [searchParams] = useSearchParams();
  const walletReward = useSelector((state) => state.wallet.coins);
  const [originalAmount] = useState(
    Number(
      location.state?.payableAmount 
        ? location.state?.payableAmount
        : localStorage.getItem("payableAmount")
    )
    // Math.round(
    //   Number(
    //     location.state?.payableAmount ?? localStorage.getItem("payableAmount")
    //   )
    // )
  );
  const [offerDetail, setOfferDetails] = useState(location.state?.offerDetail || {});

  // console.log("Selected Coupon Details :", offerDetail);
  // console.log("Outlet Deatils :",outletDetails)
  // console.log("Selected offerDetails :",offerDetail);

  const [outletDiscountValue, setOutletDiscountValue] = useState(offerDetail.discountValue);
  const [minOrderAmt, setMinOrderAmt] = useState(offerDetail.minOrderAmt);
  const [outletDiscountType, setOutletDiscountType] = useState(offerDetail.discountType);

  useEffect(()=> {
    setOutletDiscountValue(offerDetail.discountValue)
    setMinOrderAmt(offerDetail.minOrderAmt)
    setOutletDiscountType(offerDetail.discountType)
  },[offerDetail])

  const [walletAmount, setWalletAmount] = useState(0);
  const [rewardAmount, setRewardAmount] = useState(0);
  const [isRewardApplied, setIsRewardApplied] = useState(false);
  const [message, setMessage] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuccessOrder, setIsSuccessOrder] = useState(false);
  const [statusIcon, setStatusIcon] = useState({});
  const [orderID, setOrderID] = useState();
  const [isLoader, setIsLoader] = useState(false);
  const [isOfferDetailOpen, setIsOfferDetailOpen] = useState(false);
  const [modalOffer, setModalOffer] = useState({});
  const [selectedOfferIndex, setSelectedOfferIndex] = useState(null)
  const [expanded, setExpanded] = useState(false);
  const [promoCode, setPromoCode] = useState(null);
  const [promoBtnText, setPromoBtnText] = useState("Apply");
  const [promoCodeRes, setPromoCodeRes] = useState(null);
  const [promoCodeAlert, setPromoCodeAlert] = useState(null);
  const [isPromoAvailable, setIsPromoAvailable] = useState(false);
  const [redeemCodeDiscount ,setRedeemCodeDiscount] = useState(0);
  const [wasOutletDiscountRemoved, setWasOutletDiscountRemoved] = useState(false);

  const outletDiscountAmount = discountCalculator(
    outletDiscountType,
    originalAmount,
    outletDiscountValue
  );

  const amountAfterOutletDiscount = (
    originalAmount - (originalAmount >= minOrderAmt && offerDetail?.couponId > 0? outletDiscountAmount : 0)
  ).toFixed(2);

  const handleBack = () => {
    navigate(pageUrl.PAY_BILL);
  };

  useEffect(() => {
    console.log("Wallet balance fetched : ",walletReward);
    setWalletAmount(walletReward);
    setRewardAmount(walletReward);
    const paymentRefNumber = searchParams.get("hdnRefNumber");
    setOrderID(paymentRefNumber);
    if (paymentRefNumber) {
      getPaymentStatus(paymentRefNumber);
    }

    const availablePromoCode = sessionStorage.getItem("promoCode") || "";
    const promoOutletID = parseInt(sessionStorage.getItem("promoOutletID" || ""));
    // console.log(`promoOutletID(${promoOutletID}) === outletDetails?.outletId(${outletDetails?.outletId}) : ${promoOutletID === outletDetails?.outletId}`)
    if(availablePromoCode && (promoOutletID === outletDetails?.outletId || promoOutletID === 0)){
      setPromoCode(availablePromoCode);
      setPromoBtnText("Remove");
      GetPromotionInfo(availablePromoCode);
    }
  }, []);

  useEffect(() => {
    if (promoCodeRes && promoCodeRes.discountValue > 0) {
      // Recalculate the promo discount based on the updated amountAfterOutletDiscount
      const updatedRedeemCodeDiscount = calculateRedeemCodeDiscount(promoCodeRes);
      setRedeemCodeDiscount(updatedRedeemCodeDiscount);
    }
  }, [amountAfterOutletDiscount]); // Trigger when amountAfterOutletDiscount changes

  const getPaymentStatus = async (paymentRefNumber) => {
    setIsLoader(true)
    try {
      const responseData = await PaymentStatusAPI(paymentRefNumber);
      setIsModalOpen(true);
      if (responseData?.status === "COMPLETE") {
        setIsLoader(false)
        setStatusIcon({ icon: SuccessIcon });
        setIsSuccessOrder(true);
        setMessage({
          title: "Success!",
          text: "Payment Success",
        });
      } else {
        setIsLoader(false)
        setIsSuccessOrder(false);
        setStatusIcon({ icon: ErrorIcon });
        setMessage({
          title: "Error!",
          text: "Payment Failed",
        });
      }
    } catch (error) {
      setIsLoader(false)
      console.log("PaymentValidation API Error :", error);
    }
  };

  const handleSwitch = () => {
    setIsRewardApplied(!isRewardApplied);
  };

  const handleWinRewards = async () => {
    console.log("offerDetails data :",location.state?.offerDetail);
    console.log("OutDiscountRemove :",wasOutletDiscountRemoved);
    if (location.state?.offerDetail && wasOutletDiscountRemoved) {
      console.log("Add more discount!!");
      setIsModalOpen(true);
      setMessage({
        title: "Outlet Discount Available!!",
        text: "You can apply an outlet discount to reduce the amount",
      });
      return; // Prevent proceeding to payment
    }

    setIsLoader(true);
    // const discountAmount = isRewardApplied? 
    //     promoCodeRes && promoCodeRes?.discountValue > 0? 
    //       Number(amountPayable - redeemCodeDiscount).toFixed(2) : amountPayable
    //     // amountPayable
    //   : promoCodeRes && promoCodeRes?.discountValue > 0? 
    //       Number(amountAfterOutletDiscount - redeemCodeDiscount).toFixed(2) : Number(amountAfterOutletDiscount).toFixed(2);
    
    const discountAmount = (
      isRewardApplied ?
        (promoCodeRes && promoCodeRes?.discountValue > 0 ?
          (Number(amountAfterOutletDiscount - redeemCodeDiscount) - Math.min(walletAmount, Number(amountAfterOutletDiscount - redeemCodeDiscount))).toFixed(2)
          : (Number(amountAfterOutletDiscount) - Math.min(walletAmount, Number(amountAfterOutletDiscount))).toFixed(2))
      : (promoCodeRes && promoCodeRes?.discountValue > 0 ?
        Number(amountAfterOutletDiscount - redeemCodeDiscount).toFixed(2)
        : Number(amountAfterOutletDiscount).toFixed(2)
    ));



    let rewardAmount= 0;
    let finalAmtAfterAllDisc = promoCodeRes && promoCodeRes?.discountValue > 0? Number(amountAfterOutletDiscount - redeemCodeDiscount).toFixed(2) : amountAfterOutletDiscount;

    if(isRewardApplied && walletAmount > 0){
      rewardAmount = (
        finalAmtAfterAllDisc > walletAmount
            ? finalAmtAfterAllDisc >= MAX_REWARD_POINTS
              ? (walletAmount >= MAX_REWARD_POINTS ? MAX_REWARD_POINTS : walletAmount)
              : walletAmount
            : (finalAmtAfterAllDisc >= MAX_REWARD_POINTS ? MAX_REWARD_POINTS : finalAmtAfterAllDisc)
      );
    }

    try {
      const responseData = await DineInPaymentAPI(
        outletDetails?.outletId,
        Number(originalAmount),
        Number(discountAmount),
        isRewardApplied ? rewardAmount : 0,
        promoCodeRes && promoCodeRes.discountValue > 0? promoCodeRes.couponCode : "",
        promoCodeRes && promoCodeRes.discountValue > 0? "Promo" : "",
        (Object.keys(offerDetail).length === 0)? 0 : offerDetail?.couponId,
        promoCodeRes && promoCodeRes?.id? promoCodeRes.id : 0,
      );
      if (responseData.statusCode === statusCode.successCode) {
        console.log("Success Response :", responseData)
        if (responseData.status.toLowerCase() === "complete") {
          setIsLoader(false);
          userTractionCall(outletDetails?.outletId,(Object.keys(offerDetail).length === 0)?0: offerDetail?.couponId);
          navigate(pageUrl.PAYMENT_SUMMARY, {
            state: { bookingInfo: responseData.bookingInfo },
          });
          // console.log("Payment from wallet successful!!");
        } else {
          setIsLoader(false);
          let paymentUrl = responseData?.url;
          userTractionCall(outletDetails?.outletId,(Object.keys(offerDetail).length === 0)?0: offerDetail?.couponId);
          window.location.href = paymentUrl;
          // console.log("Redirection to gatway commented!!!");
          // console.log("Response :",responseData);
        }
      }
      if (responseData.statusCode === statusCode.errorCode) {
        console.log("Error Response :", responseData)
        setIsLoader(false);
        setIsModalOpen(true);
        setIsSuccessOrder(false);
        setStatusIcon({ icon: ErrorIcon });
        setMessage({
          title: "Error!",
          text: responseData.message,
        });
      }
    } catch (error) {
      setIsLoader(false);
      console.log("DineInPaymentAPI---", error);
    }
  };

  const userTractionCall = async (selectedId, OfferId) => {
    let EventNo = 6;
    let IsPayNowClicked = true;
    try {
      const response = await UserTraction({
        EventNo: EventNo,
        SelectedOutlet: selectedId,
        PayNowClick: IsPayNowClicked,
        SelectedOfferId: OfferId
      });
    } catch (error) {
      console.error('API error:', error);
    }
  }

  const handlePromoCodeChange = (e) => {
    setPromoCode(e.target.value);
    if(promoCodeAlert){
      setPromoCodeAlert(null);
    }
  };

  const percentDiscount = (payableAmount, offerAmount, maxDiscount, minAmount) => {
    if(payableAmount > minAmount){ //Payable amount must be greater then min transaction amount
      const AmtAfterDiscount = (payableAmount * offerAmount) / 100;
      if(AmtAfterDiscount > maxDiscount) {
        return maxDiscount;
      }else{
        return AmtAfterDiscount;
      }
    }else{
      return 0;
    }
  };
  
  const flatDiscount = (payableAmount, offerAmount, minAmount) => {
    if(payableAmount > minAmount){ //Payable amount must be greater then min transaction amount
      if( payableAmount > offerAmount){  //check if the offer amount is greater then the payable amount
        return offerAmount;
      }else{
        return 0;
      }
    }else{
      return 0;
    }
  };

  const calculateRedeemCodeDiscount = (couponDetails) => {
    //let payableFinalAmt = !isRewardApplied? Number(amountAfterOutletDiscount).toFixed(2) : amountPayable;
    const payableFinalAmt = Number(amountAfterOutletDiscount).toFixed(2);
    const discountType = couponDetails.discountType?.toLowerCase();

    switch (discountType) {
      case "%":
        return percentDiscount(payableFinalAmt, couponDetails.discountValue, couponDetails.maxDiscountAmount, couponDetails.minTransactionAmount);
      case "percentage":
        return percentDiscount(payableFinalAmt, couponDetails.discountValue, couponDetails.maxDiscountAmount, couponDetails.minTransactionAmount);
      case "flat":
        return flatDiscount(payableFinalAmt, couponDetails.discountValue, couponDetails.minTransactionAmount);
      default:
        return 0;
    }
  }

  const resetPromoCode = () => {
    setPromoCode("");
    setPromoBtnText("Apply");
    setIsPromoAvailable(false);
    setPromoCodeAlert(null);
    setPromoCodeRes(null);
    setRedeemCodeDiscount(0);
  }

  const GetPromotionInfo = async(promotionCode) => {
    if (promoBtnText === "Remove") {
      // Reset the promo code
      resetPromoCode();
      return;
    }

    if (!promotionCode || promotionCode.trim() === "") {
      setPromoCodeAlert("Enter Valid Code!!");
      return;
    }

    setPromoBtnText("Applying...");
    setIsPromoAvailable(true);
    try{
      const PromoResponse = await GetPromoCodeInfo(promotionCode, outletDetails?.outletId);
      if(PromoResponse[0]?.id !== 0){
        console.log("Promo Code Response :", PromoResponse[0]);
        setPromoCodeRes(PromoResponse[0]);
        setPromoBtnText("Remove");
        setPromoCodeAlert("Code Applied!!");
        let FinalDiscountValue = calculateRedeemCodeDiscount(PromoResponse[0]);
        console.log("FinalDiscountValue :",FinalDiscountValue);
        if(FinalDiscountValue === 0){
          setPromoCodeRes(null);
          setPromoBtnText("Remove");
          setPromoCodeAlert("Cannot be applied!!");
        }else{
          setRedeemCodeDiscount(FinalDiscountValue);
        }
      } else {
        setPromoBtnText("Remove");
        setPromoCodeAlert("Code Not Found!!");
      }
    } catch(e) {
      console.log("Error while calling PROMO CODE API :",e);
      setPromoBtnText("Remove");
      setPromoCodeAlert("Invalid Code!!");
    }
  }

  const handleCloseModal = () => {
    setIsModalOpen(false);
    if (isSuccessOrder) {
      navigate(pageUrl.PAYMENT_SUMMARY, { state: { orderID: orderID } });
    }
    // Don't think below condition is necessary and it also cleares the location state data
    //  else {
    //   navigate("/break-up");
    // }
  };

  const validateOffer = async (outletId, billAmount, couponId) => {
    setIsLoader(true)
    try{
      const response = await ValidateOffer(
        outletId,
        billAmount,
        couponId
      );
      setIsLoader(false)
      return response[0]
    }catch(e){
      setIsLoader(false)
      console.log("Best Offer API Error :",e)
    }
  }

  const applyOffer = async(offer, index) => {
  
    if (selectedOfferIndex === index || offerDetail?.couponId === offer.couponId) {
      setSelectedOfferIndex(null);
      // setOfferDetail({});
      setOfferDetails({})
      if (location.state?.offerDetail) {
        setWasOutletDiscountRemoved(true);
      }
    } else {
      let validateOfferRes = await validateOffer(outletDetails?.outletId, originalAmount, offer.couponId)
  
      if (validateOfferRes === undefined || validateOfferRes.couponId === 0) {
        setMessage({
          title: "Not Applicable!!",
          text: "Offer cannot be applied",
        });
        setIsModalOpen(true);
        return;
      }
      // if(promoCodeRes && promoCodeRes.discountValue > 0){
      //   resetPromoCode();
      // }
      setSelectedOfferIndex(index);
      setOfferDetails(validateOfferRes);
      setWasOutletDiscountRemoved(false); // Reset since the discount is applied
    }
  }

  const openOfferDetail = (offer) => {
    setModalOffer(offer);
    setIsOfferDetailOpen(true);
  }

  const handleOfferClose = () => {
    setIsOfferDetailOpen(false);
  };

  const expandConditions = () => {
    setExpanded(!expanded);
  };

  const amountPayable = (
    amountAfterOutletDiscount >= walletAmount
      ? amountAfterOutletDiscount >= MAX_REWARD_POINTS && walletAmount >= MAX_REWARD_POINTS
        ? (amountAfterOutletDiscount - MAX_REWARD_POINTS).toFixed(2)
        : (amountAfterOutletDiscount - walletAmount).toFixed(2)
      : amountAfterOutletDiscount >= MAX_REWARD_POINTS && walletAmount >= MAX_REWARD_POINTS
        ? (amountAfterOutletDiscount - MAX_REWARD_POINTS).toFixed(2)
        : 0
  );
  // console.log("Offer :",offerDetail);
  return (
    <div className="discount-page">
      <div className="discount-page-content">
      {isLoader && <Loader />}
      <Header
        coin={walletAmount}
        onClick={handleBack}
        label={outletDetails?.outletName}
        location={outletDetails?.locality}
      />
      <div className="discount-section">
        {
          (originalAmount >= minOrderAmt && offerDetail?.couponId > 0) && promoCodeRes && promoCodeRes.discountValue > 0 ?
            <div className="discount-text">
              🥳 You’re saving <span>&#8377;</span>
              {(Number(redeemCodeDiscount) + Number(outletDiscountAmount)).toFixed(0)} on this bill
            </div>
          :
          (originalAmount >= minOrderAmt && offerDetail?.couponId > 0) || promoCodeRes && promoCodeRes.discountValue > 0 ?
            <div className="discount-text">
              🥳 You’re saving <span>&#8377;</span>
              {promoCodeRes && promoCodeRes.discountValue > 0 ? redeemCodeDiscount : outletDiscountAmount} on this bill
            </div> 
          : null
        }
        <div className={
            Object.keys(offerDetail).length > 0?
              offerDetail.couponId === 0? "amount":"discounted-amount"
            : promoCodeRes && promoCodeRes.discountValue > 0? "discounted-amount" : "amount"
          }
        >
          <span>&#8377;</span>
          {
            promoCodeRes && promoCodeRes.discountValue > 0?
              Number(amountAfterOutletDiscount - redeemCodeDiscount).toFixed(0) 
            :
              Number(amountAfterOutletDiscount)
          }
          {/* {Number(amountAfterOutletDiscount)} */}
        </div>
        {(originalAmount >= minOrderAmt && offerDetail?.couponId > 0) || (promoCodeRes && promoCodeRes.discountValue > 0) ? 
        (
          <>
          <del className="discount-amount">
            <span>&#8377;</span>
            {originalAmount}
          </del>
          <div className="discount-ribbons">
            <Lottie loop={false} animationData={Ribbons} />
          </div>
          </>
        ):null}
        <div className="edit-amount" onClick={handleBack}>
          Edit amount
        </div>
      </div>
      <div className="offer-section">
        <RestoDetail 
          name={outletDetails?.outletName}
          address={outletDetails.address}
          locality={outletDetails?.locality}
          city={outletDetails?.city}
          avgPrice={outletDetails?.avgTowPrice}
          type={outletDetails?.type}
        />
        {
          outletDetails?.outletOffers?.map((offer, index) => (
              <OfferCard
                key={index}
                discountType={offer.discountType}
                offerAmt={offer.discountValue}
                offerText={offer.offerName}
                minOrderAmt={offer.minOrderAmt}
                offerSelected={offerDetail?.couponId === offer.couponId}
                applyButton={true}
                onClick={()=>{
                  openOfferDetail(offer)
                }}
                onApply={() =>{
                  applyOffer(offer, index)
                }}
              />
          ))
        }
      </div>
      {/* <RestoCard
        name={outletDetails.outletName}
        address={outletDetails.address}
        locality={outletDetails.locality}
        outletLogo={outletDetails?.outletMedias[0]?.mediaPath}
      /> */}
      {walletAmount > 0 && (
        /* Old component calculation without redeemCodeDiscount value(Redeem Coupon) */
        // <Rewards
        //   coins={
        //     amountAfterOutletDiscount > walletAmount? 
        //       amountAfterOutletDiscount >= MAX_REWARD_POINTS && walletAmount >= MAX_REWARD_POINTS? // amountAfterOutletDiscount >= MAX_REWARD_POINTS (Previous)
        //         MAX_REWARD_POINTS
        //       : 
        //         walletAmount
        //     : amountAfterOutletDiscount >= MAX_REWARD_POINTS? 
        //         MAX_REWARD_POINTS
        //       : 
        //         Number(amountAfterOutletDiscount)
        //   }
        //   handleChange={handleSwitch}
        //   checked={isRewardApplied}
        // />

        <Rewards
          coins={
            promoCodeRes && promoCodeRes.discountValue > 0? // Apply redeemCodeDiscount if promoCodeRes is valid
                amountAfterOutletDiscount - redeemCodeDiscount > walletAmount
                ? amountAfterOutletDiscount - redeemCodeDiscount >= MAX_REWARD_POINTS &&
                  walletAmount >= MAX_REWARD_POINTS
                  ? MAX_REWARD_POINTS
                  : walletAmount
                : amountAfterOutletDiscount - redeemCodeDiscount >= MAX_REWARD_POINTS
                ? MAX_REWARD_POINTS
                : Number(amountAfterOutletDiscount - redeemCodeDiscount).toFixed(1)
            : // If no promo code, calculate normally
                amountAfterOutletDiscount > walletAmount
                ? amountAfterOutletDiscount >= MAX_REWARD_POINTS &&
                  walletAmount >= MAX_REWARD_POINTS
                  ? MAX_REWARD_POINTS
                  : walletAmount
                : amountAfterOutletDiscount >= MAX_REWARD_POINTS
                ? MAX_REWARD_POINTS
                : Number(amountAfterOutletDiscount)
          }
          handleChange={handleSwitch}
          checked={isRewardApplied}
        />
      )}

      <div className="redeem-coupon-section">
        <div className="redeem-coupon-title-text">Redeem Coupon</div>
        <input 
          className="redeem-coupon-input-field" 
          type="text" 
          placeholder="Coupon Code"
          value={promoCode}
          onChange={handlePromoCodeChange}
          disabled={isPromoAvailable} 
          maxLength={50}
        />
        {promoCodeAlert && 
          <div 
            className="redeem-coupon-alert-text"
            style={{
              color: promoCodeAlert === "Code Applied!!" ? "green" : "red",
            }}
          >{promoCodeAlert}</div>
        }
        <div 
          className="redeem-coupon-submit-btn"
          onClick={() => GetPromotionInfo(promoCode)}
        >{promoBtnText}</div>
      </div>
      <div className="bill-break-up">
        <div className="bill-amount">
          <span className="bill-text">Bill Amount</span>
          <span>
            <span>&#8377;</span> {originalAmount.toFixed(2)}
          </span>
        </div>
        {originalAmount >= minOrderAmt && offerDetail.couponId > 0?
          <div className="discount-amount">
            <span className="bill-text">Outlet Discount</span>
            <span className="discount-bill">
              <span>-&#8377;</span>{" "}
              {outletDiscountAmount.toFixed(2)}
            </span>
          </div>
          : null
        }
        {promoCodeRes && promoCodeRes.discountValue > 0?
          <div className="discount-amount">
            <span className="bill-text">Coupon Discount</span>
            <span className="discount-bill">
              <span>-&#8377;</span>{" "}
              {redeemCodeDiscount.toFixed(2)}
            </span>
          </div>
          : null
        }
        {isRewardApplied && (
          <div className="cashback-amount">
            <span className="bill-text">Rewards</span>
            <span className="cashback-bill">
              <span>-&#8377;</span>{" "}
              {
              // (amountAfterOutletDiscount > walletAmount? 
              //   amountAfterOutletDiscount >= MAX_REWARD_POINTS && walletAmount >= MAX_REWARD_POINTS? 
              //     MAX_REWARD_POINTS
              //   : 
              //     walletAmount
              // : amountAfterOutletDiscount >= MAX_REWARD_POINTS? 
              //     MAX_REWARD_POINTS
              //   : 
              //     Number(amountAfterOutletDiscount)).toFixed(2)       
              
              promoCodeRes && promoCodeRes.discountValue > 0? // Apply redeemCodeDiscount if promoCodeRes is valid
                  amountAfterOutletDiscount - redeemCodeDiscount > walletAmount
                  ? amountAfterOutletDiscount - redeemCodeDiscount >= MAX_REWARD_POINTS &&
                    walletAmount >= MAX_REWARD_POINTS
                    ? MAX_REWARD_POINTS
                    : walletAmount
                  : amountAfterOutletDiscount - redeemCodeDiscount >= MAX_REWARD_POINTS
                  ? MAX_REWARD_POINTS
                  : Number(amountAfterOutletDiscount - redeemCodeDiscount).toFixed(2)
              : // If no promo code, calculate normally
                  amountAfterOutletDiscount > walletAmount
                  ? amountAfterOutletDiscount >= MAX_REWARD_POINTS &&
                    walletAmount >= MAX_REWARD_POINTS
                    ? MAX_REWARD_POINTS
                    : walletAmount
                  : amountAfterOutletDiscount >= MAX_REWARD_POINTS
                  ? MAX_REWARD_POINTS
                  : Number(amountAfterOutletDiscount).toFixed(2)
              }
            </span>
          </div>
        )}
        <div className="payable-amount">
          <span className="payable-text">Payable Amount</span>
          {!isRewardApplied ? (
            <span className={Object.keys(offerDetail).length > 0?
              offerDetail.couponId === 0?"payable-bill":"discount-payable-bill"
              :"payable-bill"}
            >
              <span>&#8377;</span>
              {/* {Number(amountAfterOutletDiscount).toFixed(2)} //Previous code (Before Redeem Code) */}
              {Number(
                promoCodeRes && promoCodeRes.discountValue > 0
                  ? Math.max(amountAfterOutletDiscount - redeemCodeDiscount, 0) // Apply discount if valid promo code
                  : amountAfterOutletDiscount // No discount applied
              ).toFixed(2)}
            </span>
          ) : (
            <span className={Object.keys(offerDetail).length > 0?
              offerDetail.couponId === 0?"payable-bill":"discount-payable-bill"
              :"payable-bill"}
            >
              <span>&#8377;</span>
                {/* {amountPayable} //Previous code (Before Redeem Code) */} 
                {Number(
                  promoCodeRes && promoCodeRes.discountValue > 0
                    ? Math.max(amountPayable - redeemCodeDiscount, 0) // Apply discount if valid promo code
                    : amountPayable // No discount applied
                ).toFixed(2)}
            </span>
          )}
        </div>
      </div>
        <Conditions expandValue={expanded} toggleExpand={expandConditions}/>
      </div>
      <div className="paynow-btn-section">
        <Button
          btnText="Pay Now"
          btnStyle="button-style"
          onClick={handleWinRewards}
        />
      </div>
      {isModalOpen && (
        <ModalPopUp
          className="paybill-modal"
          isOpen={isModalOpen}
          handleModalClose={handleCloseModal}
          message={message}
          // icon={statusIcon.icon}
        />
      )}
      {isOfferDetailOpen && (
        <OfferPopUp
          isOpen={isOfferDetailOpen}
          handleModalClose={handleOfferClose}
          offerDetail= {modalOffer}
        />
      )}
    </div>
  );
};

export default BreakUp;
